export const gradientBgClassNames =
  'bg-linear-to-r from-darker via-dark to-darker';
